import ActionsModal from 'components/Modals/ActionsModal'
import AttachmentsModal from './AttachmentsModal'
import AvailabilityRequestChangesModal from 'components/Modals/AvailabilityRequestChangesModal'
import BulletinNotificationStatusModal from 'components/Modals/BulletinNotificationStatusModal'
import BulletinSeeByModal from 'components/Modals/BulletinSeeByModal'
import BulletinSendNotificationsModal from 'components/Modals/BulletinSendNotificationsModal'
import CommentsModal from 'components/Modals/CommentsModal'
import ContactListCreationModal from 'components/Modals/contactLists/ContactListCreationModal'
import ContactListHistoryModal from 'components/Modals/contactLists/ContactListHistoryModal'
import ContactListSettingsModal from 'components/Modals/contactLists/ContactListSettingsModal'
import ContactUserAddHistoryModal from 'components/Modals/contactLists/ContactUserAddHistoryModal'
import ContactUserHistoryModal from 'components/Modals/contactLists/ContactUserHistoryModal'
import ContactUserHoursOfferedModal from 'components/Modals/contactLists/ContactUserHoursOfferedModal'
import ContactUserPriorityModal from 'components/Modals/contactLists/ContactUserPriorityModal'
import ContactUserShiftEligibilityModal from 'components/Modals/contactLists/ContactUserShiftEligibilityModal'
import ContactUsersHistoryModal from 'components/Modals/contactLists/ContactUsersHistoryModal'
import ContactUserTimesContactedModal from 'components/Modals/contactLists/ContactUserTimesContactedModal'
import CoworkerModal from 'components/Modals/CoworkerModal'
import CreateClientModal from 'components/Modals/CreateClientModal'
import DailyQuestionnaireModal from 'components/Modals/DailyQuestionnaireModal'
import DeleteAffectsConfirmationModal from 'components/Modals/DeleteAffectsConfirmationModal'
import DeleteButtonModal from 'components/Modals/DeleteButtonModal'
import DeleteSearchPresetConfirmationModal from 'components/Modals/DeleteSearchPresetConfirmationModal'
import DropDownDateFilterButtonModal from 'components/Modals/filters/DropDownDateFilterButtonModal'
import DropDownFiltersButtonModal from 'components/Modals/filters/DropDownFiltersButtonModal'
import DropDownHeroFilterModal from 'components/Modals/filters/DropDownHeroFilterModal'
import DropDownSavedPresetsModal from 'components/Modals/filters/DropDownSavedPresetsModal'
import EmployeeAttributeExpirationConfirmationModal from 'components/Modals/EmployeeAttributeExpirationConfirmationModal'
import EmployeeRequestsSummaryModal from 'components/Modals/EmployeeRequestsSummaryModal'
import EmployeeScheduleIssuesModal from 'components/Modals/EmployeeScheduleIssuesModal'
import EmployeeScheduleProjectInformationModal from 'components/Modals/EmployeeScheduleProjectInformationModal'
import EmployeeShiftConfirmationModal from 'components/Modals/EmployeeShiftConfirmationModal'
import EmployeeTimeOffRequestsModal from 'components/Modals/EmployeeTimeOffRequestsModal'
import FeedbackModal from 'components/Modals/FeedbackModal'
import FilterDeleteModal from 'components/Modals/FilterDeleteModal'
import GeolocationConfirmationModal from 'components/Modals/GeolocationConfirmationModal'
import GeolocationRequestModal from 'components/Modals/GeolocationRequestModal'
import ImportantInformationModal from 'components/Modals/ImportantInformationModal'
import LaunchPunchTerminalModal from 'components/Modals/punch/LaunchPunchTerminalModal'
import ManagerNavFavoritesModal from 'components/Modals/ManagerNavFavoritesModal'
import MapModal from 'components/Modals/MapModal'
import OverlappingAttendancesModal from 'components/Modals/punch/OverlappingAttendancesModal'
import OverlappingTimeoffsModal from 'components/Modals/punch/OverlappingTimeoffsModal'
import PasteEmployeeNumbersModal from 'components/Modals/users/PasteEmployeeNumbersModal'
import PasteProjectCodesModal from 'components/Modals/projects/PasteProjectCodesModal'
import PayReportConfirmationModal from 'components/Modals/PayReportConfirmationModal'
import ProcedureDeleteModal from 'components/Modals/ProcedureDeleteModal'
import ProfileImageZoomInModal from 'components/Modals/ProfileImageZoomInModal'
import ProfilePictureUploadModal from 'components/Modals/ProfilePictureUploadModal'
import ProgressModal from 'components/Modals/ProgressModal'
import ProjectBulkEditModal from 'components/Modals/projects/ProjectBulkEditModal'
import PunchAddCommentModal from 'components/Modals/punch/PunchAddCommentModal'
import PunchCardCommentsModal from 'components/Modals/punch/PunchCardCommentsModal'
import PunchCardDiffModal from 'components/Modals/punch/PunchCardDiffModal'
import PunchEndBreakModal from 'components/Modals/punch/PunchEndBreakModal'
import PunchInOutModal from 'components/Modals/punch/PunchInOutModal'
import PunchInOutModalGeolocation from 'components/Modals/punch/PunchInOutModalGeolocation'
import PunchLockDateModal from 'components/Modals/punch/PunchLockDateModal'
import PunchProjectTransferModal from 'components/Modals/punch/PunchProjectTransferModal'
import PunchQuestionnaireModal from 'components/Modals/PunchQuestionnaireModal'
import PunchStartBreakModal from 'components/Modals/punch/PunchStartBreakModal'
import PunchTerminalShutdown from 'components/Modals/punch/PunchTerminalShutdown'
import PunchTransferModal from 'components/Modals/punch/PunchTransferModal'
import ResetPasswordModal from 'components/Modals/ResetPasswordModal'
import SaveSearchModal from 'components/Modals/SaveSearchModal'
import ScheduleAssignEmployeeModal from 'components/Modals/schedule/ScheduleAssignEmployeeModal'
import ScheduleCancelModal from 'components/Modals/schedule/ScheduleCancelModal'
import ScheduleCapacityDetailModal from 'components/Modals/schedule/ScheduleCapacityDetailModal'
import ScheduleConfirmChangesModal from 'components/Modals/schedule/ScheduleConfirmChangesModal'
import ScheduleConfirmPasteModal from 'components/Modals/schedule/ScheduleConfirmPasteModal'
import ScheduleCreateAttendance from 'components/Modals/schedule/ScheduleCreateAttendance'
import ScheduleDeleteModal from 'components/Modals/schedule/ScheduleDeleteModal'
import ScheduleEditModal from 'components/Modals/schedule/ScheduleEditModal'
import ScheduleExportPDFModal from 'components/Modals/schedule/ScheduleExportPDFModal'
import ScheduleFinalizeModal from 'components/Modals/schedule/ScheduleFinalizeModal'
import ScheduleFixUserEligibilityProblemsModal from 'components/Modals/schedule/ScheduleFixUserEligibilityProblemsModal.tsx'
import ScheduleHelpModal from './schedule/ScheduleHelpModal'
import ScheduleHistoryModal from './schedule/ScheduleHistoryModal'
import ScheduleMobileActionsModal from 'components/Modals/schedule/ScheduleMobileActionsModal'
import ScheduleMultiEditModal from 'components/Modals/schedule/ScheduleMultiEditModal'
import ScheduleNotesModal from 'components/Modals/schedule/ScheduleNotesModal'
import ScheduleOpenEmployeeSchedule from './schedule/ScheduleOpenEmployeeSchedule'
import SchedulePublishModal from 'components/Modals/schedule/SchedulePublishModal'
import ScheduleQuickAssignModal from 'components/Modals/schedule/ScheduleQuickAssignModal'
import ScheduleRestoreModal from 'components/Modals/schedule/ScheduleRestoreModal'
import ScheduleSelectAutofillProcedureModal from 'components/Modals/schedule/ScheduleSelectAutofillProcedureModal'
import ScheduleTemplateApplyModal from 'components/Modals/scheduleTemplate/ScheduleTemplateApplyModal'
import ScheduleTemplateDatesModal from 'components/Modals/scheduleTemplate/ScheduleTemplateDatesModal'
import ScheduleTemplateESTModal from 'components/Modals/scheduleTemplate/ScheduleTemplateESTModal'
import ScheduleTemplateEventEditModal from 'components/Modals/scheduleTemplate/ScheduleTemplateEventEditModal'
import ScheduleTemplateEventMultiEditModal from 'components/Modals/scheduleTemplate/ScheduleTemplateEventMultiEditModal'
import ScheduleTemplateInfoModal from 'components/Modals/scheduleTemplate/ScheduleTemplateInfoModal'
import ScheduleTemplatesImportScheduleModal from 'components/Modals/scheduleTemplate/ScheduleTemplatesImportScheduleModal'
import ScheduleUnassignEmployeeModal from 'components/Modals/schedule/ScheduleUnassignEmployeeModal'
import ScheduleUnpublishModal from 'components/Modals/schedule/ScheduleUnpublishModal'
import SearchHelpModal from 'components/Modals/SearchHelpModal'
import SelectPunchAction from 'components/Modals/SelectPunchAction'
import SortDeleteModal from 'components/Modals/SortDeleteModal'
import StartContactListConfirmationModal from 'components/Modals/StartContactListConfirmationModal'
import TableExportModal from 'components/Modals/TableExportModal'
import TableOptionsModal from 'components/Modals/TableOptionsModal'
import TimeOffMultiCreateModal from 'components/Modals/TimeOffMultiCreateModal'
import TimeOffSCEModal from 'components/Modals/TimeOffSCEModal'
import UnpunchedShiftsModal from 'components/Modals/punch/UnpunchedShiftsModal'
import UnreadBulletinModal from 'components/Modals/UnreadBulletinModal'
import UserArchiveModal from 'components/Modals/users/UserArchiveModal'
import UserAttachmentsModal from 'components/Modals/UserAttachmentsModal'
import UserAttributesRemindersHistoryModal from 'components/Modals/users/UserAttributesRemindersHistoryModal'
import UserBulkEditModal from 'components/Modals/users/UserBulkEditModal'
import UserComputedPermissions from 'components/Modals/users/UserComputedPermissions'
import UserDeleteModal from 'components/Modals/users/UserDeleteModal'
import UserDiffModal from 'components/Modals/users/UserDiffModal'
import UserOnboardingModal from 'components/Modals/users/UserOnboardingModal'
import UserPasswordChangeModal from 'components/Modals/users/UserPasswordChangeModal'
import UserPinChangeModal from 'components/Modals/users/UserPinChangeModal'
import UsersArchiveModal from 'components/Modals/users/UsersArchiveModal'
import UserUsernameChangeModal from 'components/Modals/users/UserUsernameChangeModal'

export default {
  ActionsModal,
  AttachmentsModal,
  AvailabilityRequestChangesModal,
  BulletinNotificationStatusModal,
  BulletinSeeByModal,
  BulletinSendNotificationsModal,
  CommentsModal,
  ContactListCreationModal,
  ContactListHistoryModal,
  ContactListSettingsModal,
  ContactUserAddHistoryModal,
  ContactUserHistoryModal,
  ContactUserHoursOfferedModal,
  ContactUserPriorityModal,
  ContactUserShiftEligibilityModal,
  ContactUsersHistoryModal,
  ContactUserTimesContactedModal,
  CoworkerModal,
  CreateClientModal,
  DailyQuestionnaireModal,
  DeleteAffectsConfirmationModal,
  DeleteButtonModal,
  DeleteSearchPresetConfirmationModal,
  DropDownDateFilterButtonModal,
  DropDownFiltersButtonModal,
  DropDownHeroFilterModal,
  DropDownSavedPresetsModal,
  EmployeeAttributeExpirationConfirmationModal,
  EmployeeRequestsSummaryModal,
  EmployeeScheduleIssuesModal,
  EmployeeScheduleProjectInformationModal,
  EmployeeShiftConfirmationModal,
  EmployeeTimeOffRequestsModal,
  FeedbackModal,
  FilterDeleteModal,
  GeolocationConfirmationModal,
  GeolocationRequestModal,
  ImportantInformationModal,
  LaunchPunchTerminalModal,
  ManagerNavFavoritesModal,
  MapModal,
  OverlappingAttendancesModal,
  OverlappingTimeoffsModal,
  PasteEmployeeNumbersModal,
  PasteProjectCodesModal,
  PayReportConfirmationModal,
  ProcedureDeleteModal,
  ProfileImageZoomInModal,
  ProfilePictureUploadModal,
  ProgressModal,
  ProjectBulkEditModal,
  PunchAddCommentModal,
  PunchCardCommentsModal,
  PunchCardDiffModal,
  PunchEndBreakModal,
  PunchInOutModal,
  PunchInOutModalGeolocation,
  PunchLockDateModal,
  PunchProjectTransferModal,
  PunchQuestionnaireModal,
  PunchStartBreakModal,
  PunchTerminalShutdown,
  PunchTransferModal,
  ResetPasswordModal,
  SaveSearchModal,
  ScheduleAssignEmployeeModal,
  ScheduleCancelModal,
  ScheduleCapacityDetailModal,
  ScheduleConfirmChangesModal,
  ScheduleConfirmPasteModal,
  ScheduleCreateAttendance,
  ScheduleDeleteModal,
  ScheduleEditModal,
  ScheduleExportPDFModal,
  ScheduleFinalizeModal,
  ScheduleFixUserEligibilityProblemsModal,
  ScheduleHelpModal,
  ScheduleHistoryModal,
  ScheduleMobileActionsModal,
  ScheduleMultiEditModal,
  ScheduleNotesModal,
  ScheduleOpenEmployeeSchedule,
  SchedulePublishModal,
  ScheduleQuickAssignModal,
  ScheduleRestoreModal,
  ScheduleSelectAutofillProcedureModal,
  ScheduleTemplateApplyModal,
  ScheduleTemplateDatesModal,
  ScheduleTemplateESTModal,
  ScheduleTemplateEventEditModal,
  ScheduleTemplateEventMultiEditModal,
  ScheduleTemplateInfoModal,
  ScheduleTemplatesImportScheduleModal,
  ScheduleUnassignEmployeeModal,
  ScheduleUnpublishModal,
  SearchHelpModal,
  SelectPunchAction,
  SortDeleteModal,
  StartContactListConfirmationModal,
  TableExportModal,
  TableOptionsModal,
  TimeOffMultiCreateModal,
  TimeOffSCEModal,
  UnpunchedShiftsModal,
  UnreadBulletinModal,
  UserArchiveModal,
  UserAttachmentsModal,
  UserAttributesRemindersHistoryModal,
  UserBulkEditModal,
  UserComputedPermissions,
  UserDeleteModal,
  UserDiffModal,
  UserOnboardingModal,
  UserPasswordChangeModal,
  UserPinChangeModal,
  UsersArchiveModal,
  UserUsernameChangeModal
}
